// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"ii","innerTile":"ji","heading":"ki","instaTileBtn":"li","disabled":"mi","instaTileElement":"ni","instagramPic":"oi"};